import { Nav, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import MenuSearchComponent from 'components/desktop/_general/AddMenuOrRecipe/MenusList/MenuSearchComponent';
import RecipeSearchComponent from 'components/desktop/_general/AddMenuOrRecipe/RecipesList/RecipeSearchComponent';
import 'components/desktop/_general/Modal/Modal.scss';

interface IProps {
	sourceItemType: 'menu' | 'menuCopy' | 'menuPlan';
	sourceItemId: string | null;
	rowNumber?: number;
	colNumber?: number;
	finalizeAdding: () => void;
}

const AddToMenuOrRecipe = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<>
			{!props.sourceItemType.includes('menuPlan') && (
				<RecipeSearchComponent
					SourceOfAddingCol={props.colNumber ?? 0}
					SourceOfAddingId={props.sourceItemId}
					SourceOfAddingRow={props.rowNumber ?? 0}
					SourceOfAddingType={props.sourceItemType}
					finalizeAdding={props.finalizeAdding}
				/>
			)}
			{props.sourceItemType == 'menuPlan' && (
				<Tab.Container defaultActiveKey="recipes">
					<Nav variant="tabs" className="justify-content-center">
						<Nav.Item>
							<Nav.Link eventKey="recipes">
								<i className="fas fa-utensils"></i> {t('_general:RECIPES')}
							</Nav.Link>
						</Nav.Item>
						{props.sourceItemType == 'menuPlan' && (
							<Nav.Item>
								<Nav.Link eventKey="menus">
									<i className="fas fa-burger-soda"></i> {t('_general:MENUS')}
								</Nav.Link>
							</Nav.Item>
						)}
					</Nav>

					<Tab.Content>
						<Tab.Pane eventKey="recipes">
							<div style={{ marginTop: '1rem' }}>
								<RecipeSearchComponent
									SourceOfAddingCol={props.colNumber ?? 0}
									SourceOfAddingId={props.sourceItemId}
									SourceOfAddingRow={props.rowNumber ?? 0}
									SourceOfAddingType={props.sourceItemType}
									finalizeAdding={props.finalizeAdding}
								/>
							</div>
						</Tab.Pane>
						<Tab.Pane eventKey="menus">
							<div style={{ marginTop: '1rem' }}>
								<MenuSearchComponent
									SourceOfAddingCol={props.colNumber ?? 0}
									SourceOfAddingId={props.sourceItemId}
									SourceOfAddingRow={props.rowNumber ?? 0}
									SourceOfAddingType={props.sourceItemType}
									finalizeAdding={props.finalizeAdding}
								></MenuSearchComponent>
							</div>
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			)}
		</>
	);
};

export default AddToMenuOrRecipe;
